export const LOOTBOX_COSTS = {
    common: 10,
    rare: 50,
    epic: 250,
};
